<template>
  <pui-dialog
    ref="dialog"
    :showCloseButton="true"
    @outsideClick="onRequestClose"
    transition="slide-up"
  >
    <div slot="title">
      <div slot="primary">
        {{ $t('poster.editor.manual.title') }}
      </div>
    </div>
    <template #default>
      <div>
        <h1>Comportement de l'éditeur</h1>
        <div>
          <ul>
            <li>
              Au chargement l'éditeur récupérera les dernières valeurs sauvegardées du template, des
              types et des values dans le localStorage.
            </li>
            <li>
              Il est maintenant possible d'activer ou de désactiver le refresh automatique. Le
              refresh automatique s'appliquera 500ms après le dernier changement constaté. Une
              sauvegarde dans le localStorage est également effectuée à ce moment.
            </li>
            <li>
              Il est également possible de supprimer le cache des components template.
            </li>
            <li>
              Quitter la page est maintenant impossible si les données n'ont pas été sauvegardées au
              préalable.
            </li>
          </ul>
        </div>
        <h1>Actions clavier possibles</h1>
        <div>
          <ul>
            <li>
              CTRL + S : sauvegarde du template, des types et des values dans le localStorage, mise
              à jour du renderer.
            </li>
            <!-- <li>
              SHIFT + TAB : réindentation de la sélection dans l'éditeur JSON.
            </li> -->
            <li>
              Pour les actions de base,
              <a href="https://codemirror.net/6/docs/ref/#commands.defaultKeymap" target="_blank">
                voir la documentation ici
              </a>
            </li>
          </ul>
        </div>
        <h1>
          Signification des pictos
        </h1>
        <div>
          <ul>
            <li>
              <span class="picto mdi mdi-check" style="color: green; font-size: 2em"></span>
              Template synchronisé avec le rendering.
            </li>
            <li>
              <span class="picto mdi mdi-sync" style="color: orange; font-size: 2em"></span>
              Template en cours de synchronisation avec le rendering.
            </li>
            <li>
              <span class="picto mdi mdi-sync" style="color: red; font-size: 2em"></span>
              Template non synchronisé avec le rendering.
            </li>
            <li>
              <span class="picto mdi mdi-alert" style="color: red; font-size: 2em"></span>
              Template en erreur
            </li>
          </ul>
        </div>
      </div>
    </template>
  </pui-dialog>
</template>
<script>
export default {
  name: 'pui-manual-editor-dialog',
  methods: {
    onRequestClose() {
      this.$refs.dialog.close();
    },
    open() {
      this.$refs.dialog.open();
    },
  },
};
</script>
